// Mock Device Data
// Extracted from demo-data/deviceData.ts

export interface DeviceDataEntry {
  id: string;
  user_id: string;
  device_type: string;
  reading_value: number;
  reading_unit: string;
  timestamp: string;
  created_at: string;
}

export const mockDeviceData: DeviceDataEntry[] = [
  {
    id: '1',
    user_id: 'demo-user-id',
    device_type: 'blood_glucose',
    reading_value: 120,
    reading_unit: 'mg/dL',
    timestamp: new Date().toISOString(),
    created_at: new Date().toISOString()
  },
  {
    id: '2',
    user_id: 'demo-user-id',
    device_type: 'blood_pressure',
    reading_value: 120,
    reading_unit: 'mmHg',
    timestamp: new Date().toISOString(),
    created_at: new Date().toISOString()
  },
  {
    id: '3',
    user_id: 'demo-user-id',
    device_type: 'weight',
    reading_value: 150,
    reading_unit: 'lbs',
    timestamp: new Date().toISOString(),
    created_at: new Date().toISOString()
  }
]; 